<template>
  <a-statistic title="拥有量" :value="deal.amount" class="demo-class">
    <template #prefix>
      <span>当前拥有</span>
    </template>
    <template #suffix>
      <span>{{ product_point.point_name}}</span>
    </template>
  </a-statistic>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UsableProductPoint',
  props: {
    product_point: {
      type: Object,
      default:  () => ({
        content: ''
      })
    },
    deal: {
      type: Object,
      default: () => ({
        amount: ''
      })
    }
  },
});
</script>

<style scoped></style>
